


































































































import { Component, Vue } from 'vue-property-decorator';

import util from '../lib/util';
import dataLanguages from '@/data/languages';
import { ILanguage } from '@/store/entities/ILanguage';
import currencies from '@/data/currencies';
@Component
export default class HeaderHome extends Vue {
  scrollPosition = null;
  currency = currencies;
  selectedCurrency: string = this.$store.state.currency.id;
  selectedLanguage: any = {};
  languages = dataLanguages;

  created() {
    this.$store.dispatch({
      type: 'currency/init',
    });
    this.selectedLanguage = this.languages.find(
      (t) => t.locale === localStorage.lang
    );
    this.selectedCurrency = this.$store.state.currency.id;
  }

  handleSelectedCurrency(e: any) {
    localStorage.currency = e.target.textContent;
    this.$store.dispatch({
      type: 'currency/getCurrency',
      data: e.target.textContent,
    });
    this.selectedCurrency = this.$store.state.currency.id;
       var toogle =   this.$refs.toggler as any;
    toogle.click();
  }
  handleLanguage(language: any) {
   
    const matchedLanguage = this.languages.find(
      (lang) => lang.locale === language.locale
    );
    this.selectedLanguage = matchedLanguage;
    localStorage.lang = matchedLanguage.locale;
    this.$i18n.locale = matchedLanguage.locale;
    
    var toogle =   this.$refs.toggler as any;
    toogle.click();
  }

  updateScroll() {
    this.scrollPosition = window.scrollY;
  }

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  }
}
